import VueCookies from 'vue-cookies'; 
export default {
    getToken(state) {
        return VueCookies.get('token');
        // return state.token;
    },
    getExpiration(state) {
        return state.expiration;
    },
    getUsername(state) {
        return state.username;
    },
    getTokenDetails(state) {
        var token = VueCookies.get('token')

        // no cookie, or not a well formed JWT
        if (!token || token.split('.').length !== 3)
            return null;

        try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

            return JSON.parse(jsonPayload);
        } catch (e) {
            return null;
        }
    },
    getUserView(state, getters) {
        return getters.getTokenDetails?.View?.toLowerCase() ?? '';
    },
    getUseMetric(state, getters) {
        var metric = getters.getTokenDetails?.Metric;

        // claim missing -> metric, the way the system has always behaved
        if (metric === undefined || metric === null || metric === '')
            return true;

        return String(metric).toLowerCase() !== 'false';
    }
};
